import { inject, Injectable } from '@angular/core';
import { environment } from '@env';
import { type WS, wsBuilder } from '@shared/ws/ws';
import { AuthService } from '@tvd/data-access/auth';
import type { NotificationEvent } from '@shared/models/notification';

export type NotificationWsMessage =
  | NotificationEvent
  | { type: 'connected'; unreadCount: number; timestamp: string }
  | { type: 'unread-count'; count: number }
  | { type: 'pong'; timestamp: string };

@Injectable({ providedIn: 'root' })
export class NotificationWs {
  readonly #token = inject(AuthService).token;

  #ws?: WS<NotificationWsMessage> = undefined;

  connect() {
    const token = this.#token();
    if (!token) return undefined;

    this.destroy();

    const url = `${environment.wsUrl}/notifications/websocket?token=${token}`;
    this.#ws = wsBuilder<NotificationWsMessage>(url)
      .withRetry(5, 3000)
      .create();
    this.#ws.connect();
    return this.#ws.messages$;
  }

  destroy() {
    if (this.#ws) {
      this.#ws.close();
      this.#ws = undefined;
    }
  }
}
